import { useCallback } from 'react';
import { useIntercom } from 'react-use-intercom';
import { IntercomPageContext } from './types';

/**
 * This hook is used to manage the Intercom chat widget.
 * This wraps the useIntercom hook from react-use-intercom incase we need to apply more logic.
 *
 * @returns {Object} - An object containing the functions.
 */
export function useIntercomManager() {
	const { update, show } = useIntercom();

	const showIntercom = useCallback(
		(pageContext?: IntercomPageContext) => {
			update({
				customAttributes: {
					page_context: pageContext,
				},
			});
			show();
		},
		[update, show]
	);

	return { showIntercom };
}
